<template>
    <a-drawer
        :title="id === 0 ? 'Añadir nuevo proveedor' : 'Editar proveedor #' + id"
        :width="420"
        :visible="visible"
        :wrap-style="{ height: '100%', overflow: 'auto', paddingBottom: '108px' }"
        @close="$emit('close')"
    >
        <validation-observer v-slot="{ passes, invalid }">
            <form @submit="passes(save)">
                <div class="row">
                    <div class="col-6">
                        <g-field
                            v-model="fields.name"
                            :app="app"
                            :item="id"
                            name="name"
                            title="Nombre"
                        />
                    </div>
                    <div class="col-6">
                        <g-field
                            v-model="fields.cif"
                            :app="app"
                            :item="id"
                            name="cif"
                            title="NIF / CIF"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.legal_name"
                            :app="app"
                            :item="id"
                            name="legal_name"
                            title="Nombre fiscal"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.address"
                            :app="app"
                            :item="id"
                            name="address"
                            title="Dirección"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <g-field
                            v-model="fields.cp"
                            :app="app"
                            :item="id"
                            name="cp"
                            title="Código Postal"
                        />
                    </div>
                    <div class="col-6">
                        <g-field
                            v-model="fields.location"
                            :app="app"
                            :item="id"
                            name="location"
                            title="Población"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <g-field
                            v-model="fields.state"
                            :app="app"
                            :item="id"
                            name="state"
                            title="Provincia"
                        />
                    </div>
                    <div class="col-6">
                        <g-field
                            v-model="fields.country"
                            :app="app"
                            :item="id"
                            name="country"
                            title="Pais"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.phone"
                            :app="app"
                            :item="id"
                            name="phone"
                            title="Teléfono"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.email"
                            :app="app"
                            :item="id"
                            name="email"
                            title="Email"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <g-field
                            v-model="fields.bic_swift"
                            :app="app"
                            :item="id"
                            name="bic_swift"
                            title="BIC / SWIFT"
                        />
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-12">
                        <g-field
                            v-model="fields.iban"
                            :app="app"
                            :item="id"
                            name="iban"
                            title="IBAN"
                        />
                    </div>
                </div>

                <div
                    :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        padding: '10px 16px',
                        textAlign: 'right'
                    }"
                >
                    <a-button
                        :style="{ marginRight: '8px' }"
                        @click="$emit('close')"
                    >
                        Cancelar
                    </a-button>
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="loading"
                        :disabled="invalid"
                    >
                        {{ id === 0 ? 'Añadir' : 'Modificar' }}
                    </a-button>
                </div>
            </form>
        </validation-observer>
    </a-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            view: 'providerList',
            app: 'providers',
            loading: false,
            fields: {
                legal_name: '',
                address: '',
                country: '',
                cif: '',
                cp: null,
                email: '',
                iban: '',
                bic_swift: '',
                location: '',
                name: '',
                state: '',
                phone: ''
            }
        };
    },
    methods: {
        async save() {
            this.loading = true;

            const params = { ...this.fields };

            let data;
            if (this.id > 0) {
                data = await this.$gestios.items('providers').edit({ id: this.id, params });
            } else {
                data = await this.$gestios.items('providers').add({ params, view: this.view });
            }

            if (data.ok) this.$emit('close');

            this.loading = false;
        }
    }
};
</script>

<style>
</style>
